export const POSTS_REF = 'dashboard/posts';

export default function (_this) {
  return {
    add (post) {
      return new Promise((resolve) => {
        getRef().push(post, (res) => {
          resolve(res)
        });
      })
    },
    getAll (cb) {
      getRef().once('value', (snapshot) => {
        const posts = [];
        const map = snapshot.val() || {};
        for (let key in map) {
          posts.push({
            id: key,
            ...map[key],
            date: new Date(map[key].date)
          });
        }
        cb(posts);
      });
    },
    getAllByRecord(recordId, cb) {
      this.getAll((posts) => {
        cb(posts.filter(post => post.record === recordId))
      })
    },
    deleteAll() {
      return getRef().remove()
    },
    delete (id) {
      getRef()
        .child(id)
        .remove()
    },
    getRef
  }

  function getRef() {
    return _this.getRef(POSTS_REF);
  }
}
